import { Component, Inject, ViewChild, OnInit, ViewEncapsulation } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { DomSanitizer } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { InvisibleReCaptchaComponent } from 'ngx-captcha';

import { LzCookieService } from '../../../../services/lz-cookie/lz-cookie';
import { LzUserServiceV2 } from '../../../lz-user/services/lz-user.serivce.v2';
import { LzFeedbackService } from '../../../lz-feedback/services/lz-feedback.service';
import { LzPurchaseService } from '../../../lz-purchase/services/lz-purchase.service';
import { CustomRequestService } from '../../../../services/custom-request/custom-request.service';
import { LzProductConfig } from '../../../../services/product-config/poduct-config';

declare var grecaptcha: any;

@Component({
  selector: 'lz-popup',
  template: `<div class="lz-popup-container">

  <span class="close" (click)="closeDialog()">
    <span class="line line-left"></span>
    <span class="line line-right"></span>
  </span>

  <div class="title" *ngIf="popupData.title">
    {{popupData.title}}
  </div>

  <div class="subtitle" *ngIf="popupData.subTitle">
    {{popupData.subTitle}}
  </div>

  <img class="image" *ngIf="popupData.image" [src]="popupData.image" />

  <div class="video" *ngIf="popupData.video" [innerHTML]="popupData.video"></div>

  <form class="popup-form" *ngIf="(popupData.fields && popupData.fields.length > 0) || (popupData.consents && popupData.consents.length > 0)">
    <div class="fields-set" *ngIf="popupData.fields && popupData.fields.length > 0">
      <div *ngFor="let field of popupData.fields">
        <input placeholder="{{'lz-popup.placeholder_' + field | translate}}" [name]="formInputs[field].id" *ngIf="!(formInputs[field].id === 'phone' && !isDisableMask) || isDisableMask"
          [(ngModel)]="formInputs[field].value" (ngModelChange)="checkInputRequired(formInputs[field])" (change)="checkInputPattern(formInputs[field])"
          [ngClass]="{'not-empty': formInputs[field].value.length > 0, 'input-error': isInit && (formInputs[field].isError1 || formInputs[field].isError2)}"
          maxlength="256" required />
        <input placeholder="{{'lz-popup.placeholder_' + field | translate}}" [name]="formInputs[field].id" *ngIf="formInputs[field].id === 'phone' && !isDisableMask"
          [(ngModel)]="formInputs[field].value" (ngModelChange)="checkInputRequired(formInputs[field])" (change)="checkInputPattern(formInputs[field])"
          [ngClass]="{'not-empty': formInputs[field].value.length > 0, 'input-error': isInit && (formInputs[field].isError1 || formInputs[field].isError2)}"
          maxlength="256" [textMask]="{mask: MASK, showMask: false}" required />
        <span class="error" *ngIf="formInputs[field].isError2">{{'lz-popup.' + formInputs[field].errorTextPattern |
          translate}}</span>
        <span class="error" *ngIf="!formInputs[field].isError2 && formInputs[field].isError3 && formInputs[field].errorText">{{formInputs[field].errorText}}</span>
      </div>
    </div>

    <div class="server-error" *ngIf="serverError">
      <span>{{'lz-popup.server_error' | translate}}</span>
    </div>

    <div class="checks-set" *ngIf="popupData.consents && popupData.consents.length > 0">
      <div *ngFor="let check of popupData.consents">
        <span class="error" *ngIf="check.isError">{{'lz-popup.checkbox_error' | translate}}</span>
        <span class="box-check" [ngClass]="{'checked': check.checked}" (click)="checkItem(check)">
          <i class="fa fa-check"></i>
        </span>
        <div class="check-item" [innerHTML]="check.text"></div>
      </div>
    </div>
  </form>

  <div class="feedback" *ngIf="popupData.isFeedbackBlock">
    <span class="feedback-title">{{'lz-popup.opinion' | translate}}</span>
    <span class="feedback-action" (click)="showFeedback()"><span>{{'lz-popup.feedback' | translate}}</span><i class="fa fa-envelope"></i></span>
  </div>

  <form [formGroup]="cFormGroup">
    <ngx-invisible-recaptcha #captchaRef hl="uk" siteKey="6LcfMkgUAAAAAOmzWe6krfV-cgR3MczaQVrqxUVR" (success)="submit($event)"
      formControlName="recaptcha">
    </ngx-invisible-recaptcha>
  </form>

  <div class="submit" *ngIf="popupData.buttonText && popupData.buttonUrl">
    <button class="submit-button" (click)="checkForm(captchaRef)" [ngClass]="{'disable': showLoader, 'required-disable': checkRequired()}"
      *ngIf="popupData.buttonUrl == '#TEST#' || popupData.buttonUrl == '#LEAD#'">
      <span *ngIf="!showLoader">{{popupData.buttonText}}</span>
      <lz-preloader *ngIf="showLoader"></lz-preloader>
    </button>
    <a class="submit-button" [href]="popupData.buttonUrl" target="_blank" *ngIf="popupData.buttonUrl != '#TEST#' && popupData.buttonUrl != '#LEAD#'">
      {{popupData.buttonText}}
    </a>
  </div>

  <div class="popup-form show-never" *ngIf="popupData.isRefusalEnabled">
    <div class="checks-set show-never">
      <span class="box-check" [ngClass]="{'checked': isNeverShow}" (click)="clickNeverShow()">
        <i class="fa fa-check"></i>
      </span>
      <div class="check-item">
        <p>
          {{'lz-popup.show_never' | translate}}
        </p>
      </div>
    </div>
  </div>

</div>
`,
  styles: [`::ng-deep .cdk-overlay-container{z-index:1111}::ng-deep .cdk-overlay-container ::ng-deep .cdk-overlay-pane{max-width:100vw!important}::ng-deep .cdk-overlay-container ::ng-deep .cdk-overlay-pane ::ng-deep .mat-dialog-container{margin:0;padding:0;max-height:95vh;border-radius:0}@media (max-width:757px){::ng-deep .cdk-overlay-container ::ng-deep .cdk-overlay-pane ::ng-deep .mat-dialog-container{max-height:80vh}}::ng-deep .cdk-global-scrollblock{position:static!important;overflow:hidden}::ng-deep .cdk-global-scrollblock body{overflow:hidden}.lz-popup-container{position:relative;height:auto;max-height:80vh;padding:44px 0 0;margin:0;font-family:Geometria;overflow-x:hidden;width:370px}.lz-popup-container .close{position:absolute;width:35px;height:35px;top:10px;right:10px;text-align:center;cursor:pointer;z-index:1}.lz-popup-container .close .line{position:absolute;display:block;width:20px;height:1px;background-color:rgba(0,0,0,.4);-webkit-transform:rotate(45deg);transform:rotate(45deg);top:22px;margin-top:-10px;left:50%;margin-left:-10px}.lz-popup-container .close .line.line-left{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.lz-popup-container .title{position:relative;display:block;padding:0 30px;font-size:36px;line-height:36px;color:#303f9f;font-weight:600;margin:0 0 20px}.lz-popup-container .subtitle{position:relative;display:block;padding:0 30px;font-size:18px;color:rgba(0,0,0,.502);font-weight:500;margin:0 0 20px}.lz-popup-container .image,.lz-popup-container .video{position:relative;display:block;width:100%;height:auto;padding:0;margin:0 0 20px}.lz-popup-container .popup-form{position:relative;display:block;margin:0}.lz-popup-container .popup-form.show-never{padding:0 0 30px}.lz-popup-container .popup-form .fields-set{position:relative;display:block;padding:0 30px;margin:0 0 25px}.lz-popup-container .popup-form .fields-set input{position:relative;display:block;width:100%;height:auto;margin:0 0 10px;font-size:16px;padding:8px 0;line-height:16px;border:none;border-bottom:1px solid rgba(146,146,146,.502);color:#929292}.lz-popup-container .popup-form .fields-set input:focus{border-bottom:1px solid #ffbe26}.lz-popup-container .popup-form .fields-set input::-webkit-input-placeholder{font-style:normal;color:rgba(146,146,146,.502);font-weight:400}.lz-popup-container .popup-form .fields-set input::-ms-input-placeholder{font-style:normal;color:rgba(146,146,146,.502);font-weight:400}.lz-popup-container .popup-form .fields-set input::placeholder{font-style:normal;color:rgba(146,146,146,.502);font-weight:400}.lz-popup-container .popup-form .fields-set input.not-empty{border-bottom:1px solid #303f9f}.lz-popup-container .popup-form .fields-set input.input-error{color:#ff564e;border-bottom:1px solid #ff564e}.lz-popup-container .popup-form .fields-set input.input-error::-webkit-input-placeholder{color:#ff564e}.lz-popup-container .popup-form .fields-set input.input-error::-ms-input-placeholder{color:#ff564e}.lz-popup-container .popup-form .fields-set input.input-error::placeholder{color:#ff564e}.lz-popup-container .popup-form .fields-set .error{position:absolute;z-index:1;background-color:#ff564e;color:#fff;font-size:12px;line-height:12px;padding:2px 5px;margin-top:-18px;display:block;width:310px}@media (max-width:575px){.lz-popup-container{width:320px}.lz-popup-container .popup-form .fields-set .error{width:255px}}.lz-popup-container .popup-form .server-error{position:relative;display:block;width:100%;padding:0 30px;margin:0 0 25px;font-size:14px}.lz-popup-container .popup-form .server-error span{position:relative;display:block;background-color:#ff564e;color:#fff;padding:0 5px}.lz-popup-container .popup-form .checks-set{position:relative;display:block;width:100%;padding:0 28px;margin-bottom:20px}.lz-popup-container .popup-form .checks-set .error{position:absolute;z-index:1;background-color:#ff564e;color:#fff;font-size:12px;line-height:12px;padding:2px 5px;margin-top:23px;display:block;width:310px}@media (max-width:575px){.lz-popup-container .popup-form .checks-set .error{width:255px}}.lz-popup-container .popup-form .checks-set .error::before{content:'';display:block;position:absolute;width:6px;height:6px;top:-3px;left:8px;background-color:#ff564e;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.lz-popup-container .popup-form .checks-set .box-check{position:absolute;display:block;width:23px;height:23px;border:1px solid #303f9f;cursor:pointer;text-align:center;z-index:1;margin-top:-5px}.lz-popup-container .popup-form .checks-set .box-check i{display:none;font-size:14px;color:#303f9f;font-weight:600;top:-1px;position:relative}.lz-popup-container .popup-form .checks-set .box-check.checked i{display:inline}.lz-popup-container .popup-form .checks-set .check-item{position:relative;display:block;margin:15px 0;padding-left:35px;top:0}.lz-popup-container .popup-form .checks-set .check-item p{margin:0;font-size:12px;line-height:14px;color:#303f9f}.lz-popup-container .popup-form .checks-set .check-item p a{font-size:12px;line-height:14px;color:#ffbe26;text-decoration:none;cursor:pointer}.lz-popup-container .popup-form .checks-set.show-never{margin-bottom:0}.lz-popup-container .popup-form .checks-set.show-never .box-check{margin-top:-4px;border:1px solid #929292}.lz-popup-container .popup-form .checks-set.show-never .box-check i,.lz-popup-container .popup-form .checks-set.show-never .check-item p{color:#929292}.lz-popup-container .feedback{position:relative;display:block;padding:0 30px;margin:0 0 20px;text-align:center}.lz-popup-container .feedback .feedback-title{position:relative;display:block;color:#000;font-size:18px;line-height:18px;margin-bottom:20px;font-weight:500}.lz-popup-container .feedback .feedback-action{position:relative;display:block;font-size:12px;line-height:12px;color:#303f9f;font-weight:600;margin-bottom:30px}.lz-popup-container .feedback .feedback-action span{cursor:pointer}.lz-popup-container .feedback .feedback-action i{color:#ffbe26;margin-left:7px;position:relative;font-size:17px;cursor:pointer;top:1px}.lz-popup-container .submit{position:relative;display:block;padding:0 30px;margin:0 0 30px}.lz-popup-container .submit .submit-button{position:relative;display:block;width:100%;height:auto;background-color:#ffbe26;color:#303f9f;font-size:16px;font-weight:600;padding:10px 0;border:none;text-align:center}.lz-popup-container .submit .submit-button:focus,.lz-popup-container .submit .submit-button:hover,.lz-popup-container .submit .submit-button:link,.lz-popup-container .submit .submit-button:visited{text-decoration:none}.lz-popup-container .submit .submit-button:focus{outline:0}.lz-popup-container .submit .submit-button.disable{pointer-events:none;padding:18.5px 0 18.5px 143px}.lz-popup-container .submit .submit-button.required-disable{pointer-events:none;opacity:.7}`],
  host: {
    '(click)': 'onClickInside($event)',
    '(document:click)': 'onClickOutside($event)',
  }
})

export class LzPopupComponent implements OnInit {
  @ViewChild(InvisibleReCaptchaComponent) captcha: InvisibleReCaptchaComponent;
  public resolved(captchaResponse: string) {}

  public cFormGroup: FormGroup;

  public isInit = false;

  public formInputs: any = {};
  public isDisableMask = false;
  public isNeverShow = false;
  public showLoader = false;
  public disableClosing = false;
  public serverError = false;

  public MASK = ['+', '3', '8', '0', ' ', '(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  private EMAIL_REGEXP = /^[a-z0-9._-]+@[a-z0-9._-]+\.[a-z0-9]{2,}$/gi;
  private PHONE_REGEXP = /(^\+\d{3} \(\d{2}\) \d{3}-\d{2}-\d{2}$)|(^\d{10}$)|(^\+?\d{12}$)/g;
  private userInfo: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public popupData: any,
    public dialogRef: MatDialogRef < LzPopupComponent > ,
    private sanitizer: DomSanitizer,
    private feedback: LzFeedbackService,
    private user: LzUserServiceV2,
    private cookie: LzCookieService,
    private purchase: LzPurchaseService,
    private request: CustomRequestService,
    private config: LzProductConfig
  ) {

    if (this.popupData.consents && this.popupData.consents.length > 0) {
      for (let i = 0, ilen = this.popupData.consents.length; i < ilen; i += 1) {
        this.popupData.consents[i].text = this.popupData.consents[i].text.replace(new RegExp('<p', 'g'), '<p class="margin: 0; font-size: 12px; line-height: 14px; color: #303f9f;" ');
        this.popupData.consents[i].text = this.popupData.consents[i].text.replace(new RegExp('<a', 'g'), '<a class="font-size: 12px; line-height: 14px; color: #ffbe26; text-decoration: none; cursor: pointer;" ');
        this.popupData.consents[i].text = this.sanitizer.bypassSecurityTrustHtml(this.popupData.consents[i].text);
      }
    }

    if (this.popupData.video && this.popupData.video.length > 0) {
      this.popupData.video = this.sanitizer.bypassSecurityTrustHtml(this.popupData.video);
    }

    if (this.popupData.fields && this.popupData.fields.length > 0) {
      for (let i = 0, ilen = this.popupData.fields.length; i < ilen; i += 1) {
        this.formInputs[this.popupData.fields[i]] = {}
        this.formInputs[this.popupData.fields[i]].id = this.popupData.fields[i];
        this.formInputs[this.popupData.fields[i]].value = '';
      }
    }

    this.user.getUserInfo((msg) => {
      this.userInfo = msg;
      if (this.userInfo && !this.userInfo.anonymous) {
        if (this.userInfo.email && this.userInfo.email.length > 0 && this.formInputs['email']) {
          this.formInputs['email'].value = this.userInfo.email;
        }
        if (this.userInfo.name && this.userInfo.name.length > 0 && this.formInputs['firstName']) {
          this.formInputs['firstName'].value = this.userInfo.name;
        }
        if (this.userInfo.lastName && this.userInfo.lastName.length > 0 && this.formInputs['lastName']) {
          this.formInputs['lastName'].value = this.userInfo.lastName;
        }
        if (this.userInfo.phone && this.userInfo.phone.length > 0 && this.formInputs['phone']) {
          this.isDisableMask = true;
          this.formInputs['phone'].value = this.userInfo.phone;
        }
        if (this.userInfo.client && this.userInfo.client.name && this.userInfo.client.name.length > 0 && this.formInputs['companyName']) {
          this.formInputs['companyName'].value = this.userInfo.client.name;
        }
      }
    });
  }

  ngOnInit() {
    this.isInit = true;
    this.cFormGroup = new FormGroup({
      'recaptcha': new FormControl()
    });
  }

  onClickInside(event) {
    event.stopPropagation();
  }

  onClickOutside(event) {
    try {
      if (event.type === 'click' && (event.button === 1 || event.button === 2)) {
        return;
      }
    } catch(e) { }

    if (!this.disableClosing) {
      event.preventDefault();
      this.closeDialog();
    }
  }

  public checkItem = (item) => {
    if (!item.checked) {
      item.checked = true;
      item.isError = false;
    } else {
      item.checked = false;
    }
  }

  public checkInputRequired = (input): boolean => {
    if (input.value.length === 0) {
      input.isError1 = true;
    } else {
      input.isError1 = false;
    }
    if (input.id === 'email') {
      if (input.value.match(this.EMAIL_REGEXP)) {
        input.isError2 = false;
      }
    }
    if (input.id === 'phone') {
      if (input.value.match(this.PHONE_REGEXP)) {
        input.isError2 = false;
      }
    }
    input.isError3 = false;
    input.errorText = '';
    return input.isError1;
  }

  public checkInputPattern = (input) => {
    if (input.id === 'email') {
      if (!input.value.match(this.EMAIL_REGEXP)) {
        input.isError2 = true;
        input.errorTextPattern = 'input_error_email_pattern';
      } else {
        input.isError2 = false;
        input.errorTextPattern = '';
      }
      input.isError3 = false;
      input.errorText = '';
      return input.isError2;
    }
    if (input.id === 'phone') {
      if (!input.value.match(this.PHONE_REGEXP)) {
        input.isError2 = true;
        input.errorTextPattern = 'input_error_phone_pattern';
      } else {
        input.isError2 = false;
        input.errorTextPattern = '';
      }
      input.isError3 = false;
      input.errorText = '';
      return input.isError2;
    }
  }

  public checkForm = (captchaRef) => {
    let isError = false;

    if (this.popupData.fields && this.popupData.fields.length > 0) {
      for (let i = 0, ilen = this.popupData.fields.length; i < ilen; i += 1) {
        if (this.checkInputRequired(this.formInputs[this.popupData.fields[i]]) || this.checkInputPattern(this.formInputs[this.popupData.fields[i]])) {
          isError = true;
        }
      }
    }

    if (this.popupData.consents && this.popupData.consents.length > 0) {
      for (let i = 0, ilen = this.popupData.consents.length; i < ilen; i += 1) {
        if (!this.popupData.consents[i].checked) {
          this.popupData.consents[i].isError = true;
          isError = true;
        }
      }
    }

    if (isError) {
      return;
    }

    this.captcha.resetCaptcha();
    try {
      grecaptcha.reset();
    } catch (e) {}

    captchaRef.execute();
  }

  public submit = (captchaResponse: string) => {

    this.showLoader = true;

    switch (this.popupData.buttonUrl) {
      case '#TEST#':
        this.showLoader = false;
        this.purchase.doPurchaseNew(!!(this.popupData.productAlias) ? this.popupData.productAlias : undefined);
        this.closeDialog();
        break;
      case '#LEAD#':
        let data: any = {};
        data['popup_alias'] = this.popupData.id || '';
        data['g-recaptcha-response'] = captchaResponse || '';
        data['trial'] = true;
        data['productCode'] = this.config.getProductSettings()['order_code'] ? this.config.getProductSettings()['order_code'] : '';
        data['firstName'] = '';
        data['lastName'] = '';
        data['phone'] = '';
        data['companyName'] = '';
        data['email'] = '';

        if (this.userInfo && !this.userInfo.anonymous) {
          if (!data['firstName']) {
            data['firstName'] = (this.userInfo.name) ? this.userInfo.name : '';
          }
          if (!data['lastName']) {
            data['lastName'] = (this.userInfo.lastName) ? this.userInfo.lastName : '';
          }
          if (!data['phone']) {
            data['phone'] = (this.userInfo.phone) ? this.userInfo.phone : '';
          }
          if (!data['email']) {
            data['email'] = (this.userInfo.email) ? this.userInfo.email : '';
          }
          if (!data['companyName']) {
            data['companyName'] = (this.userInfo.client && this.userInfo.client.name) ? this.userInfo.client.name : '';
          }
        }

        if (this.popupData.fields && this.popupData.fields.length > 0) {
          for (let i = 0, ilen = this.popupData.fields.length; i < ilen; i += 1) {
            console.log(this.formInputs[this.popupData.fields[i]]);
            if (this.formInputs[this.popupData.fields[i]] && this.formInputs[this.popupData.fields[i]].value) {
              if (this.popupData.fields[i] === 'phone') {
                data[this.popupData.fields[i]] = encodeURIComponent(this.formInputs[this.popupData.fields[i]].value.replace(/[\)\(\- ]/g, ''));
              } else {
                data[this.popupData.fields[i]] = this.formInputs[this.popupData.fields[i]].value;
              }
            }
          }
        }

        this.sendLead(data);
        return;
      default:
        this.closeDialog();
        return;
    }
  }

  public closeDialog = () => {
    if (!this.serverError) {
      if (this.popupData.frequency) {
        try {
          let date = new Date();
          switch (this.popupData.frequency) {
            case 'day':
              this.cookie.createCookie('popupShowDate' + this.popupData.id, date.setDate(date.getDate() + 1).toString(), 365);
              break;
            case 'week':
              this.cookie.createCookie('popupShowDate' + this.popupData.id, date.setDate(date.getDate() + 7).toString(), 365);
              break;
            case 'month':
              this.cookie.createCookie('popupShowDate' + this.popupData.id, date.setMonth(date.getMonth() + 1).toString(), 365);
              break;
            default:
              break;
          }
        } catch (e) {
          console.log("Error while saving date to cookie: ", e);
        }
      }
    }
    this.dialogRef.close();
  }

  public showFeedback = () => {
    this.disableClosing = true;
    this.feedback.openFeedbackDialog(() => {
      setTimeout(() => {
        this.disableClosing = false;
      }, 0);
    });
  }

  public clickNeverShow = () => {
    this.isNeverShow = !this.isNeverShow;
    if (this.isNeverShow) {
      this.cookie.createCookie('popupNeverShow' + this.popupData.id, 'true', 365);
    } else {
      this.cookie.deleteCookie('popupNeverShow' + this.popupData.id);
    }
  }

  public checkRequired = () => {

    if (this.serverError) {
      return true;
    }

    let isError = false;

    if (this.popupData.fields && this.popupData.fields.length > 0) {
      for (let i = 0, ilen = this.popupData.fields.length; i < ilen; i += 1) {
        if (this.formInputs[this.popupData.fields[i]].value.length === 0 || this.formInputs[this.popupData.fields[i]].isError3) {
          isError = true;
        }
      }
    }

    if (this.popupData.consents && this.popupData.consents.length > 0) {
      for (let i = 0, ilen = this.popupData.consents.length; i < ilen; i += 1) {
        if (!this.popupData.consents[i].checked) {
          isError = true;
        }
      }
    }

    return isError;
  }

  private sendLead = (data) => {
    if ((this.config.getProductSettings()['order_code']) && (this.config.getProductSettings()['order_code']).length > 0) {
      this.request.postRequestWithFormData(
        this.config.getApiLink() + '/lz-platforma/crm/v1.0/addLead/' + this.popupData.id || 'undefined',
        data,
        undefined, {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      ).subscribe((msg) => {
        this.showLoader = false;
        if (msg && msg.isOk) {
          this.closeDialog();
        } else {
          this.captcha.resetCaptcha();
          try {
            grecaptcha.reset();
          } catch (e) {}
          if (msg.message) {
            for (let key in msg.message) {
              if (msg.message.hasOwnProperty(key)) {
                if (this.formInputs[key]) {
                  this.formInputs[key].isError3 = true;
                  this.formInputs[key].errorText = msg.message[key];
                }
              }
            }
            if (msg.message.formMessage) {
              this.serverError = true;
            }
          }
        }
      }, (errMsg) => {
        this.showLoader = false;
        this.serverError = true;
      });
    }
  }

}
